import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { setViewedMinuteRequestAction } from 'core/actions';

interface IProps {
  videoUrl: string;
  eventId: number;
}

const getVideoId = (url: string): string => {
  const raw = (url || '').trim();
  if (!raw) return '';
  // Try regex first (works with or without scheme, any casing)
  const match = raw.match(/\/(?:video|shorts)\/(?:private\/)?([a-zA-Z0-9_-]+)/i);
  if (match && match[1]) return match[1];
  try {
    const fullUrl = raw.startsWith('http') ? raw : `https://${raw}`;
    const path = new URL(fullUrl).pathname;
    const segments = path.split('/').filter(Boolean);
    const videoIndex = segments.findIndex((s) => s.toLowerCase() === 'video');
    const shortsIndex = segments.findIndex((s) => s.toLowerCase() === 'shorts');
    if (videoIndex !== -1 && segments[videoIndex + 1] === 'private' && segments[videoIndex + 2]) {
      return segments[videoIndex + 2];
    }
    if (videoIndex !== -1 && segments[videoIndex + 1] && segments[videoIndex + 1] !== 'private') {
      return segments[videoIndex + 1];
    }
    if (shortsIndex !== -1 && segments[shortsIndex + 1]) {
      return segments[shortsIndex + 1];
    }
  } catch {
    // already tried regex above
  }
  return '';
};

export const Rutube = ({ videoUrl, eventId }: IProps) => {
  const dispatch = useDispatch();
  const [viewedMinutes, setViewedMinutes] = useState(0);
  const [viewedSeconds, setViewedSeconds] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setViewedSeconds((s: number) => s + 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    setViewedMinutes(Math.floor(viewedSeconds / 60));
  }, [viewedSeconds]);

  useEffect(() => {
    if (viewedMinutes > 0) {
      dispatch(setViewedMinuteRequestAction(eventId));
    }
  }, [dispatch, viewedMinutes, eventId]);

  const videoId = getVideoId(videoUrl);
  if (!videoId) return null;

  const embedSrc = `https://rutube.ru/play/embed/${videoId}/`;

  return (
    <iframe
      src={embedSrc}
      frameBorder="0"
      style={{ border: 'none' }}
      allow="clipboard-write; autoplay; fullscreen; picture-in-picture"
      allowFullScreen
      title="video"
    />
  );
};
